/**
 * Register all available CharJS charts.
 *
 * We will modify the draw function of the DoughnutChart to
 *   draw rounded corners for each visible arc.
 *
 * More available controllers :
 * 	- BubbleController,
 * 	- PolarAreaController,
 * 	- RadarController,
 * 	- ScatterController,
 */
import {
	Chart,
	BarController,
	DoughnutController as BaseDoughnutController,
	LineController as BaseLineController,
	PieController,
	elements,
	plugins,
	scales,
} from 'chart.js';
import DoughnutController from './DoughnutController';
import LineController from './LineController';

export default {
	install(Vue) {
		if (!process.server) {
			Vue.mixin({
				created() {
					BaseDoughnutController.id = 'baseDoughnut';
					DoughnutController.id = 'doughnut';
					BaseLineController.id = 'baseLine';
					LineController.id = 'line';

					Chart.register(
						{
							BarController,
							DoughnutController,
							LineController,
							PieController,
						},
						elements,
						plugins,
						scales,
					);
				},
			});

			Vue.prototype.$chartjs = (item, config) => new Chart(item, config);
		}
	},
};
